import React, { useEffect, useState } from 'react';
import { useRegisterInstance } from '../../services/hooks/use-register-instance';
import { FormAdd } from '../FormAdd';
export const InstanceCreate = ({ onCreated }) => {
    const [validationBackend, setValidationBackend] = useState(null);
    // Список агентов инвалидируется внутри мутации - обновлять таблицу вручную не нужно.
    const { mutate: registerInstance, data: registerInstanceResponse, isLoading } = useRegisterInstance(setValidationBackend);
    useEffect(() => {
        if (registerInstanceResponse?.isSuccess) {
            onCreated(registerInstanceResponse.guid);
        }
    }, [registerInstanceResponse, onCreated]);
    return React.createElement(FormAdd, { onSubmit: registerInstance, pluginInstanceError: validationBackend, isSubmitting: isLoading });
};
